export enum UiNotificationType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info'
}

export interface UiNotification {
  id?: number;
  type: UiNotificationType;
  group: string;
  title: string;
  message: string;
  timeout?: number;
}
